import React from 'react';
import PropTypes from 'prop-types';
import { CSSTransition } from 'react-transition-group';

import I18n from '@module/i18n';

import PadlockIcon from '@component/icon/padlock';

export const LockedRecipient = ({
  recipient,
  showMobileInfo,
  onClick,
  onInfoClick,
}) => {
  const handleInfoClick = (event) => {
    event.stopPropagation();
    onInfoClick();
  };

  return (
    <div className="uploader__locked-recipient" onClick={onClick}>
      <span className="uploader__locked-recipient-label">
        {I18n.t('transfer.form.to')}
      </span>
      <span className="uploader__locked-recipient-email" title={recipient}>
        {recipient}
      </span>
      <PadlockIcon
        className="uploader__locked-recipient-icon"
        color="#919599"
      />
      <CSSTransition
        classNames="uploader__locked-recipient-info--fade"
        in={showMobileInfo}
        timeout={500}
        unmountOnExit
      >
        <div
          onClick={handleInfoClick}
          className="uploader__locked-recipient-info"
        >
          <div
            className="uploader__locked-recipient-title"
            dangerouslySetInnerHTML={{
              __html: I18n.t('transfer.bubble.recipient_locked_title'),
            }}
          />
          <span
            className="uploader__locked-recipient-text"
            dangerouslySetInnerHTML={{
              __html: I18n.t('transfer.bubble.recipient_locked_text'),
            }}
          />
        </div>
      </CSSTransition>
    </div>
  );
};

LockedRecipient.propTypes = {
  recipient: PropTypes.string.isRequired,
  showMobileInfo: PropTypes.bool,
  onClick: PropTypes.func.isRequired,
  onInfoClick: PropTypes.func,
};

export default React.memo(LockedRecipient);
